import { isNil } from 'lodash';

export const notEmpty = <TValue>(value: TValue | null | undefined): value is TValue => !isNil(value);
